import { useMemo } from "react";
import { Image } from "./image";

export const Gallery = (props) => {
  const gallerySources = useMemo(() => {
    return props.data ? props.data.map(d => d.largeImage) : [];
  }, [props.data]);

  return (
    <div id='portfolio' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>ОТДЫХАЙ КАК ЛЮБИШЬ!</h2>
        </div>
        <div className='row'>
          <div className='portfolio-items'>
            {props.data
              ? props.data.map((d, i) => (
                <div className='col-sm-6 col-md-4 col-lg-4' key={`gallery-${i}`}>
                  <Image
                    largeImage={d.largeImage}
                    smallImage={d.smallImage}
                    gallery={gallerySources}
                  />
                </div>
              ))
              : 'Loading...'}
          </div>
        </div>
      </div>
    </div>
  )
}
